.container {
  padding-block: 0;
  padding-inline: 0;
  margin-inline: 0;
  border: none;
}
